import{gql as e,useMutation as i,useQuery as t,useLazyQuery as r}from"@apollo/client";import o from"universal-cookie";import{useSessionContext as a}from"@exo/frontend-common-session-context";import{assembleQuery as n,handleApolloError as l}from"@exo/frontend-common-apollo";import{useCallback as d,useState as c,useEffect as s,useMemo as u}from"react";import{useHistory as p,useLocation as g}from"react-router-dom";import{CryptoHelper as f,filterMarketplaceFacets as m,TagManagerUtils as v,findOffer as y}from"exo-frontend-remote-utils";import h from"qs";const _=()=>{const t=e`
    mutation AgroLogout($client: String) {
      agroLogout(client: $client) {
        logout
      }
    }
  `,[r]=i(t,{variables:{client:process.env.APLICACAO_SOLICITACAO_PEDIDO}});return{agroLogout:()=>r()}};function b(e,i,t,r){return new(t||(t=Promise))((function(o,a){function n(e){try{d(r.next(e))}catch(e){a(e)}}function l(e){try{d(r.throw(e))}catch(e){a(e)}}function d(e){var i;e.done?o(e.value):(i=e.value,i instanceof t?i:new t((function(e){e(i)}))).then(n,l)}d((r=r.apply(e,i||[])).next())}))}"function"==typeof SuppressedError&&SuppressedError;const P=()=>{const[t]=i(e`
    mutation AskQuestion($question: String, $context: String, $client: String) {
      askQuestion(question: $question, context: $context, client: $client) {
        context
        responses {
          title
          text
          description
          options {
            label
            value
          }
          response_type
        }
        callToActionURI
      }
    }
  `);return{getAskQuestion:(e,i)=>b(void 0,void 0,void 0,(function*(){return t({variables:{question:e,context:i,client:process.env.APLICACAO_SOLICITACAO_PEDIDO}})}))}},C=e`
  mutation Auth($username: String!, $password: String!) {
    authLogin(username: $username, password: $password) {
      token
      refresh_token
    }
  }
`,S=()=>{const e=a(),t=new o,[r]=i(C);return{authenticate:(i,t)=>b(void 0,void 0,void 0,(function*(){var o,a;const n=yield r({variables:{username:i,password:t}});return e.replace({token:n.data.authLogin.token,refreshToken:null===(o=n.data.authLogin)||void 0===o?void 0:o.refresh_token,username:i,type:"USER",roles:["user"]}),{token:n.data.authLogin.token,refreshToken:null===(a=n.data.authLogin)||void 0===a?void 0:a.refresh_token,username:i}})),logout:()=>b(void 0,void 0,void 0,(function*(){e.replace({roles:[]}),t.remove("logged",{path:"/"})}))}},I=()=>{const i=e`
    query Dashboard {
      dashboard {
        banner_download {
          id
          title
          link_button
          label_button
          alt_button
          image_url
          text_flag
        }
      }
    }
  `,{data:r,loading:o,error:a}=t(i);return{data:null==r?void 0:r.dashboard.banner_download,loading:o,error:a}},k=e`
  query GetCategoriesAndSubcategories(
    $input: getCategoriesAndSubcategoriesRequest!
  ) {
    getCategoriesAndSubcategories(input: $input) {
      categories {
        items {
          id
          name
          url_key
          url_path
          path
          children {
            id
            name
            url_key
            url_path
            path
            children {
              id
              name
              url_key
              url_path
              path
              children {
                id
                name
                url_key
                url_path
                path
                children {
                  id
                  name
                  url_key
                  url_path
                  path
                }
              }
            }
          }
        }
      }
    }
  }
`,$=(e=`${process.env.MAIN_CATEGORY_MARKETPLACE}`)=>{const{data:i,error:r,loading:o}=t(k,{variables:{input:{mainCategory:e}},fetchPolicy:"cache-first"});return{data:i,error:r,loading:o}};class O{constructor(e){this.id=e.id,this.slug=e.slug}get isSlug(){return!!this.slug}get isId(){return!!this.id}get ref(){var e;return null!==(e=this.slug)&&void 0!==e?e:this.id}}const A=({categoryId:e},i)=>{var r;const o=(a=e)?a.ref?a:new O({id:a}):void 0;var a;const l={categoryId:o.ref},{called:d,loading:c,data:s,error:u}=t(n((e=>`\n        query Category($categoryId: String) {\n          category(${o.isSlug?"slug: $categoryId":"id: $categoryId"}) {\n            ${e}\n          }\n        }\n      `),i),{variables:l});return{called:d,loading:c,data:null!==(r=s&&s.category)&&void 0!==r?r:[],error:u}},L="psid-call-location",N=()=>{const e=new o,i=a(),t=p(),r=d((()=>{e.remove("psid",{path:"/"})}),[]),n=d((()=>{var t;const o=e.get("psid");if(o&&(null===(t=i.profile)||void 0===t?void 0:t.isPrivilegedUser))return f.decrypt(o);r()}),[r]),l=d(((o,a)=>{var n,l;if(r(),!(null===(n=i.profile)||void 0===n?void 0:n.isPrivilegedUser))return;const d=Number(null!==(l=process.env.PSID_MAX_AGE)&&void 0!==l?l:0),c={callPage:t.location,callPageOrigin:a},s=f.encrypt(JSON.stringify(c));sessionStorage.setItem(L,s),e.set("psid",o,{encode:f.encrypt,path:"/",maxAge:d})}),[r,t.location]),c=d(((e="/dashboardPartner/home")=>{var i,r;try{const e=null!==(i=sessionStorage.getItem(L))&&void 0!==i?i:"{}",o=JSON.parse(f.decrypt(e));if(!(null==o?void 0:o.callPage))throw new Error("Invalid psid-call-location");o.callPageOrigin&&(o.callPage.state=Object.assign(Object.assign({},null!==(r=o.callPage.state)&&void 0!==r?r:{}),{origin:o.callPageOrigin})),t.push(o.callPage)}catch(i){t.push(e)}}),[]);return{getPrivilegedSessionId:n,updatePrivilegedSessionId:l,removePrivilegedSessionId:r,goBackToStart:c}},q=e`
  query GetCreditLimit($input: CreditLimitInput!) {
    getCreditLimit(input: $input) {
      elegivel
      limite {
        ncontrLim
        cpssoaJurid
        cpssoaJuridDesc
        csitLimGerc
        descrSitAtualLim
        climIndvdGrp
        cdoctoPropn
        cgrpEconmPropn
        ccpfCnpjPropn
        cflialCpfCnpjPro
        cctrlCpfCnpjProp
        cdoctoPssoaEmprP
        nomeRzaProponente
        cpssoaPropn
        climCentroCusto
        cprodtServcOper
        descrProdtLimite
        cindcdEconmMoeda
        descrMoeda
        vlimGerc
        vutlzdLimGerc
        vdispnLimGerc
        dvctoLimGerc
        pvctoLimGerc
        cundMedd
        ccatlgGarntPrinc
        descrGarntPrinc
        ccatlgGarntOpc1
        descrGarntAdic1
        ccatlgGarntOpc2
        descrGarntAdic2
        ccatlgGarntOpc3
        descrGarntAdic3
        ccatlgGarntOpc4
        descrGarntAdic4
        ccontrProdtCoobc
        ccontrOrigeRec
        caprovCaracEspcl
        ctpoPssoaLim
        cutilzSpreTx
        ccontrCnvo
        cpssoaJuridContr
        ctpoContrNegoc
        nseqContrNegoc
        ndoctoPartcLim
      }
      motivoInelegibilidade
      clientePossuiConta
    }
  }
`,w=e`
  query GetCreditLimit($input: CreditLimitInput!) {
    getCreditLimit(input: $input) {
      clientePossuiConta
    }
  }
`,D=()=>{const e=N().getPrivilegedSessionId();return{getCreditLimit:i=>(i.privilegedSessionId=e,(e=>r(q,{variables:{input:e}}))(i))}},E=e=>{const i=N().getPrivilegedSessionId();e.privilegedSessionId=i;const r=t(q,{variables:{input:e},skip:!e,fetchPolicy:"no-cache"});return{getCreditCPRF:()=>r}},T=(e,i)=>{var r;const o=a(),n=N().getPrivilegedSessionId();e.privilegedSessionId=n,(null===(r=o.profile)||void 0===r?void 0:r.isPrivilegedUser)&&!n&&(i=!0);const l=t(q,{variables:{input:e},skip:i,fetchPolicy:"no-cache"});return{getCreditCPRF:()=>l}},R=({codigoInstituicaoFinanceira:e,codigoProduto:i})=>{const r=N().getPrivilegedSessionId(),{data:o,loading:a,error:n}=t(w,{variables:{input:{codigoInstituicaoFinanceira:e,codigoProduto:i,privilegedSessionId:r}},fetchPolicy:"no-cache"});return{getClientHasAccountData:null==o?void 0:o.getCreditLimit,getClientHasAccountLoading:a,getClientHasAccountError:n}},U=()=>{const[e,{data:i,loading:t,error:o}]=r(w,{fetchPolicy:"no-cache"});return{getCreditClientHasAccount:e,getClientHasAccountData:null==i?void 0:i.getCreditLimit,getClientHasAccountLoading:t,getClientHasAccountError:o}},F=()=>{const e=N().getPrivilegedSessionId(),[i,t]=r(q,{fetchPolicy:"no-cache"});return{creditCPRFLimit:t,getCreditCPRFLimit:t=>{if(t)return t.privilegedSessionId=e,i({variables:{input:t}})}}},j=i=>{var r,o,a,n,l;const d=e`
    query doesCityHasProductsAvailable(
      $input: DoesCityHasProductsAvailableRequest
    ) {
      doesCityHasProductsAvailable(input: $input)
    }
  `,{called:c,loading:s,data:u,error:p}=t(d,{fetchPolicy:"no-cache",variables:{input:{mirakl_region:[null===(r=null==i?void 0:i.region_rgi_id)||void 0===r?void 0:r.toString(),null===(o=null==i?void 0:i.region_rg_int_id)||void 0===o?void 0:o.toString(),null===(a=null==i?void 0:i.region_uf_id)||void 0===a?void 0:a.toString(),null===(n=null==i?void 0:i.region_rb_id)||void 0===n?void 0:n.toString(),null===(l=null==i?void 0:i.region_pais_id)||void 0===l?void 0:l.toString()]}},skip:!(null==i?void 0:i.nome_municipio)});return{called:c,loading:s,data:u,error:p}},G=()=>{const i=e`
    query GetMenuMarketplace {
      getMenuMarketplace {
        image_url
        image_url_mobile
        title
        alt
        link
      }
    }
  `,{called:r,loading:o,data:a,error:n,refetch:l}=t(i,{fetchPolicy:"cache-first"});return{called:r,loading:o,data:a,error:n,refetch:l}},x=()=>{const i=e`
    query Footer {
      footer {
        link_loja_google
        link_loja_apple
        link_instagram
        link_facebook
        link_linkedin
        link_youtube
        link_qr_code
      }
    }
  `,r=t(i,{fetchPolicy:"cache-first"});return{getFooter:()=>r}},B=()=>{const i=e`
    query LogoQuery {
      onboard {
        logo {
          id
          logo_e_agro_url
          logo_e_agro_url_alt
        }
      }
    }
  `,r=t(i);return{getHeader:()=>r}},M=e`
  query GetRegionBR {
    getRegionBR
  }
`,K=()=>{const{called:e,loading:i,data:r,error:o}=t(M,{fetchPolicy:"cache-first"});return{called:e,loading:i,data:r,error:o}},z=e`
  query GetMunicipio($uf: String) {
    getMunicipio(uf: $uf)
  }
`,H=()=>{const[e,{called:i,loading:t,data:o,error:a}]=r(z,{fetchPolicy:"no-cache"});return{getMunicipio:e,called:i,loading:t,data:{getMunicipio:JSON.parse((null==o?void 0:o.getMunicipio)||"[]")},error:a}},V=()=>{const[e,{called:i,loading:t,data:o,error:a}]=r(z,{fetchPolicy:"no-cache"});return{getMunicipio:e,called:i,loading:t,data:{getMunicipio:JSON.parse((null==o?void 0:o.getMunicipio)||"[]")},error:a}},Q=()=>{const{called:e,loading:i,data:r,error:o}=t(z,{variables:{uf:""},fetchPolicy:"no-cache"});return{called:e,loading:i,data:r,error:o}},J=i=>{const r=e`
    query GetOrderData($id: ID!) {
      getOrderData(id: $id) {
        id
        codigoModalidadeCredito
        situacaoFormalizacao
        idUsuarioSolicitacaoPedido
        perfilUsuarioSolicitacaoPedido
      }
    }
  `,{loading:o,error:a,data:n,refetch:l}=t(r,{variables:{id:i},skip:!i});return{loading:o,error:a,data:n,refetch:l}},W=e`
  query GetProductDeeplinks($urlKey: String) {
    getProductDeeplinks(urlKey: $urlKey) {
      label
      url
    }
  }
`,Z=({urlKey:e})=>{const{data:i,error:r,loading:o,refetch:a}=t(W,{variables:{urlKey:e},fetchPolicy:"network-only"});return{data:i,error:r,loading:o,refetch:a}},X=()=>{var i;const r=a(),o=e`
    query GetProfile {
      getProfile {
        fullName
        email
        cpf
        picture
        phone
      }
    }
  `,{called:n,loading:l,data:d,error:c}=t(o,{skip:null===(i=r.profile)||void 0===i?void 0:i.isPrivilegedUser});return{called:n,loading:l,data:d,error:c}},Y=e`
  query GetShippingOnProductPage($input: GetShippingOnProductPageRequest) {
    getShippingOnProductPage(input: $input) {
      status
      simulations {
        code
        label
        delivery_time
        total_shipping_price
      }
      address
      message
    }
  }
`;var ee;!function(e){e.PickUpInStore="RNL",e.Default="STD",e.Express="EXP"}(ee||(ee={}));const ie=({zipCode:e,offerId:i,offerQty:r})=>{const{data:o,error:a,loading:n,refetch:l}=t(Y,{variables:{input:{zipCode:e,offerId:i,offerQty:r}},fetchPolicy:"network-only",skip:8!==(null==e?void 0:e.length)});return{data:o,error:a,loading:n,refetch:l}},te=(i=!1)=>{var r;const o=e`
    query GetSpecialistProfile {
      getSpecialistProfile {
        fullName
        email
        cpf
        picture
        phone
      }
    }
  `,a=t(o,{skip:i});return Object.assign(Object.assign({},a),{data:null===(r=a.data)||void 0===r?void 0:r.getSpecialistProfile})},re=()=>{const[e,i]=c(void 0);return s((()=>{e&&(window.location.href=e)}),[e]),{isRedirecting:!!e,redirect:i}},oe=()=>{const t=g(),r=new URLSearchParams(""===t.hash?t.search.substring(1):t.hash.substring(1)),[o]=i(e`
    mutation RequestAuthorizationUrl(
      $callbackUri: String
      $flow: AutAuthenticationFlowType
      $client: String
    ) {
      authRequestAuthorizationUrl(
        callbackUri: $callbackUri
        flow: $flow
        client: $client
      )
    }
  `),[a]=i(e`
    mutation AuthCallback(
      $code: String
      $state: String
      $accessToken: String
      $idToken: String
      $idClaims: [AutIdClaim]
      $client: String
    ) {
      authCallback(
        code: $code
        state: $state
        accessToken: $accessToken
        idToken: $idToken
        idClaims: $idClaims
        client: $client
      ) {
        token
        wasSuccessful
        errorMessage
        refresh_token
      }
    }
  `);return{requestAuthorizationUrl:(e,i)=>b(void 0,void 0,void 0,(function*(){const t=process.env.APLICACAO_SOLICITACAO_PEDIDO,a=yield o({variables:{callbackUri:e,flow:i,client:t},fetchPolicy:"no-cache",errorPolicy:"ignore"}),n=r.get("canal")||"";return a.data.authRequestAuthorizationUrl+=`&canal=${n}`,a})),callback:(e,i,t,r,o)=>{const n=process.env.APLICACAO_SOLICITACAO_PEDIDO;return a({variables:{code:e,state:i,accessToken:t,idToken:r,idClaims:o,client:n},fetchPolicy:"no-cache",errorPolicy:"ignore"})}}},ae=()=>({loadString:function(e){return b(this,void 0,void 0,(function*(){try{return localStorage.getItem(e)}catch(e){return null}}))},saveString:function(e,i){return b(this,void 0,void 0,(function*(){try{return yield localStorage.setItem(e,i),!0}catch(e){return!1}}))},load:function(e){return b(this,void 0,void 0,(function*(){try{const i=yield localStorage.getItem(e);return i?JSON.parse(i):null}catch(e){return null}}))},save:function(e,i){return b(this,void 0,void 0,(function*(){try{return yield localStorage.setItem(e,JSON.stringify(i)),!0}catch(e){return!1}}))},remove:function(e){return b(this,void 0,void 0,(function*(){try{yield localStorage.removeItem(e)}catch(e){}}))},clear:function(){return b(this,void 0,void 0,(function*(){try{yield localStorage.clear()}catch(e){}}))}}),ne=()=>{const e=oe(),i=ae(),{redirect:t}=re(),r=()=>b(void 0,void 0,void 0,(function*(){return yield e.requestAuthorizationUrl(`${process.env.OIDC_PUBLIC_URL}/auth/custom/callback`,process.env.OIDC_FLOW||"")}));return{redirectRegister:e=>b(void 0,void 0,void 0,(function*(){const o=yield r();i.save("LinkRedirectLogin",e),t(`${o.data.authRequestAuthorizationUrl}&cadastrar=true`)})),redirectLogin:e=>b(void 0,void 0,void 0,(function*(){const i=yield r();window.localStorage.setItem("LinkRedirectLogin",`"${e}"`),t(`${i.data.authRequestAuthorizationUrl}`)}))}},le=()=>{const[t]=i(e`
    mutation GetUploadUserFileUrl($objectKey: String) {
      getUploadUserFileUrl(objectKey: $objectKey) {
        url
      }
    }
  `),[r]=i(e`
    mutation ValidateUserFile($objectKey: String) {
      validateUserFile(objectKey: $objectKey) {
        clean
        message
        code
      }
    }
  `),[o]=i(e`
    mutation DeleteUserFile($objectKey: String) {
      deleteUserFile(objectKey: $objectKey) {
        deleted
      }
    }
  `);return{getUploadUserFileUrl:e=>b(void 0,void 0,void 0,(function*(){return t({variables:{objectKey:e}})})),validateUserFile:e=>b(void 0,void 0,void 0,(function*(){return r({variables:{objectKey:e}})})),deleteUserFile:e=>b(void 0,void 0,void 0,(function*(){return o({variables:{objectKey:e}})}))}},de=new o;function ce(e){if(e&&Object.keys(e).length)return e}const se="undefined"==typeof global?de.get("marketplace"):null===global||void 0===global?void 0:global.MARKETPLACE_COOKIE;const ue=Object.seal(new class{constructor(){this.context=se||de.get("marketplace")||{},this.context=se||de.get("marketplace")||{}}get(){return ce(this.context)||de.get("marketplace")||se||{}}set(e){this.context=Object.assign(Object.assign({},ce(this.context)||de.get("marketplace")||se),e),global.MARKETPLACE_COOKIE=Object.assign(Object.assign({},ce(this.context)||de.get("marketplace")||se),e),de.set("marketplace",JSON.stringify(Object.assign(Object.assign({},ce(this.context)||de.get("marketplace")||se),e)),{path:"/"})}}),pe=()=>{const i=e`
    query GetNotificationBell {
      getNotificationBell {
        statusCode
        resultCode
        message
      }
    }
  `,{data:r}=t(i);return{data:r}};class ge{constructor(e){this.id=e.id,this.partnumber=e.partnumber,this.slug=e.slug,this.offer_id=e.offer_id}get isPartnumber(){return!!this.partnumber}get isSlug(){return!!this.slug}get isId(){return!!this.id}get ref(){var e,i;return null!==(i=null!==(e=this.slug)&&void 0!==e?e:this.partnumber)&&void 0!==i?i:this.id}get isOffer(){return!!this.offer_id}}const fe=({productId:e,currency:i,skip:r,count:o=12,cleanCache:a,url_key:l},d)=>{const c=(s=e)?s.ref?s:new ge({partnumber:s}):void 0;var s;const u={id:null==c?void 0:c.ref,count:o,currency:i,url_key:l},{called:p,loading:g,data:f,error:m}=t(n((e=>`\n        query ProductById($url_key: String, $id: String, $currency: String, $regionList: [String!], $miraklRegion: [String!]) {\n          product(${(null==c?void 0:c.isSlug)?"slug: $id":"partnumber: $id"}, url_key: $url_key, currency: $currency, regionList: $regionList, mirakl_region: $miraklRegion) {\n            ${e}\n          }\n        }\n      `),d),{variables:u,skip:null!=r?r:!e,fetchPolicy:a?"no-cache":"network-only"});return{called:p,loading:g,data:f,error:m}},me=({productId:i,miraklRegion:r,regionList:o,urlKey:a,skip:n,facets:l,mirakl_shop_ids:d})=>{const c=e`
    query Products($filter: ProductFilter!, $facets: [String!]) {
      products(filter: $filter, facets: $facets) {
        facets {
          code
          name
          type
          multiSelect
          entries {
            label
            count
            code
            state
            type
          }
        }
        edges {
          node {
            partnumber
            url_key
            name
            precisa_de_receita
            accepts_cpr_payment
            entrega_expressa
            grande_desconto
            precisa_de_cotacao
            show_price
            video_url
            marca
            mp_info {
              offers {
                additional_info {
                  json_string
                }
                product_sku
                offer_id
                price
                total_price
                quantity
                description
                shop_id
                shop_name
                formatted_price {
                  price {
                    regular_price {
                      value
                      currency
                      __typename
                    }
                    final_price {
                      value
                      currency
                      __typename
                    }
                    discount {
                      amount_off
                      percent_off
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                min_order_quantity
                shop {
                  url_key
                }
                __typename
              }
              __typename
            }
            parentCategory {
              identifier
            }
            fullImage
            selection {
              id
            }
            type
          }
        }
      }
    }
  `,{called:s,loading:u,data:p,error:g,refetch:f}=t(c,{fetchPolicy:"cache-and-network",variables:{filter:{url_key:a,term:i,mirakl_region:r,regionList:null==o?void 0:o.map((e=>e.toString())),mirakl_shop_ids:d},facets:m(l)},skip:n});return{called:s,loading:u,data:p,error:g,refetch:f}},ve=()=>{const i=e`
    query Products($filter: ProductFilter!) {
      products(filter: $filter) {
        edges {
          node {
            partnumber
            url_key
            name
            precisa_de_receita
            precisa_de_cotacao
            show_price
            video_url
            mp_info {
              offers {
                additional_info {
                  json_string
                }
                product_sku
                offer_id
                price
                total_price
                quantity
                description
                shop_id
                shop_name
                formatted_price {
                  price {
                    regular_price {
                      value
                      currency
                      __typename
                    }
                    final_price {
                      value
                      currency
                      __typename
                    }
                    discount {
                      amount_off
                      percent_off
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            fullImage
            selection {
              id
            }
            type
          }
        }
      }
    }
  `,[t,{called:o,loading:a,data:n,error:l,refetch:d}]=r(i,{fetchPolicy:"network-only"});return{getProducts:t,called:o,loading:a,data:n,error:l,refetch:d}},ye=()=>{const i=e`
    query GetStatusSSOInstitution {
      getStatusSSOInstitution {
        enabled
      }
    }
  `,{data:r}=t(i);return{redirectSSO:(e,i)=>{var t;const o=`?targetUrl=${e}&cancelUrl=${i}`;if("true"===process.env.VERIFY_SSO&&!(null===window||void 0===window?void 0:window.isWebView)&&r){const i=null===(t=null==r?void 0:r.getStatusSSOInstitution)||void 0===t?void 0:t.enabled;window.location.href=!1===i?e:"/simulationLogged/AuthBradescoPage"+o}else window.location.href="/simulationLogged/AuthBradescoPage"+o}}},he=e`
  query CartRefresh($id: ID) {
    me {
      id
      carts(cartId: $id) {
        id
        grandTotal {
          value
          currency
        }
        totalProductPrice {
          value
          currency
        }
        totalShippingCharge {
          value
          currency
        }
        totalAdjustment {
          value
          currency
        }
        totalShippingTax {
          value
          currency
        }
        totalSalesTax {
          value
          currency
        }
        adjustments {
          title
          amount {
            currency
            value
          }
        }
        mp_info {
          shipping_tax_amount {
            value
            currency
          }
          base_shipping_incl_tax {
            value
            currency
          }
          orders {
            offers {
              shipping_price_unit
              shipping_price_additional_unit
              id
              price
              quantity
              line_only_shipping_price
              line_only_total_price
              line_original_quantity
              line_price
              line_quantity
              line_shipping_price
              line_total_price
              product_category_code
              allow_quote_requests
              offer_additional_fields {
                code
                value
              }
            }
            shipping_types {
              code
              label
              additional_fields_values {
                code
                value
              }
              delivery_time {
                earliest_days
                latest_days
              }
              total_shipping_price
            }
            leadtime_to_ship
            selected_shipping_type {
              code
              label
              delivery_time {
                earliest_days
                latest_days
              }
            }
          }
        }
        shippingInfo {
          shipMode {
            id
            identifier
          }
          pickupInStore {
            id
            name
          }
          shippingAddress {
            id
            country
            zip
            province
          }
        }
        lineItems {
          id
          quantity
          partnumber
          adjustments {
            title
            amount {
              currency
              value
            }
          }
          mp_info {
            shop_name
            shop_id
            offer_id
            cpr_available
          }
          linePrice {
            currency
            value
          }
          unitPrice {
            currency
            value
          }
          shippingInfo {
            shipMode {
              id
              identifier
            }
            pickupInStore {
              id
              name
            }
            shippingAddress {
              id
              country
              zip
            }
          }
          product {
            id
            type
            thumbnail
            name
            partnumber
            description
            precisa_de_receita
            mp_info {
              offers {
                product_sku
                offer_id
                price
                total_price
                quantity
                description
                shop_id
                shop_name
                discount_price
                discount_start_date
                discount_end_date
                discount_ranges
                active
                formatted_price {
                  price {
                    regular_price {
                      value
                      currency
                    }
                    final_price {
                      value
                      currency
                    }
                    discount {
                      amount_off
                      percent_off
                    }
                  }
                }
                min_order_quantity
              }
            }
            selection {
              id
              criteria {
                id
                criteriaId
                name
                value {
                  id
                  value
                }
              }
            }
          }
        }
      }
    }
  }
`,_e=e=>{const{data:i,loading:r,refetch:o}=t(he,{fetchPolicy:"no-cache",variables:{id:e},skip:!e});return{loading:r,data:i,refetch:o}},be=i=>{var r;const o=e`
    query Seo {
      ${i} {
        seo {
          title
          description
          robots
          url_canonical
        }
      }
    }
  `,{data:a,error:n,loading:l}=t(o);return{seoQueryData:null===(r=null==a?void 0:a[i])||void 0===r?void 0:r.seo,seoQueryError:n,seoQueryLoading:l}},Pe=e`
  query SendStockNotification($input: SendStockNotificationRequest) {
    sendStockNotification(input: $input) {
      status
    }
  }
`,Ce=({input:e,sendRequest:i})=>{const{data:r,error:o,loading:a,refetch:n}=t(Pe,{variables:{input:e},fetchPolicy:"network-only",skip:!i});return{data:r,error:o,loading:a,refetch:n}};var Se,Ie;!function(e){e.rura="1019",e.pecuario="1022",e.cpr="10878",e.cprm="12382"}(Se||(Se={})),function(e){e.CLIENTE="CLIENTE",e.ESPECIALISTA="ESPECIALISTA",e.ASSESSOR="ASSESSOR_TECNICO"}(Ie||(Ie={}));const ke=(e,i)=>{var t,r,o,a;const n=T({codigoProduto:Number(Se.cpr),codigoInstituicaoFinanceira:null},v.isUserInfoSet()&&!i||!e).getCreditCPRF(),l=u((()=>{var e,i;return 2===(null===(i=null===(e=null==n?void 0:n.data)||void 0===e?void 0:e.getCreditLimit)||void 0===i?void 0:i.motivoInelegibilidade)}),[null===(r=null===(t=null==n?void 0:n.data)||void 0===t?void 0:t.getCreditLimit)||void 0===r?void 0:r.motivoInelegibilidade]),d=T({codigoProduto:Number(Se.rura),codigoInstituicaoFinanceira:null},v.isUserInfoSet()&&!i||!e).getCreditCPRF(),c=u((()=>{var e,i;return 2===(null===(i=null===(e=null==d?void 0:d.data)||void 0===e?void 0:e.getCreditLimit)||void 0===i?void 0:i.motivoInelegibilidade)}),[null===(a=null===(o=null==d?void 0:d.data)||void 0===o?void 0:o.getCreditLimit)||void 0===a?void 0:a.motivoInelegibilidade]);s((()=>{var e,i;null!=(null===(i=null===(e=null==n?void 0:n.data)||void 0===e?void 0:e.getCreditLimit)||void 0===i?void 0:i.clientePossuiConta)&&v.setUserInfo(n.data.getCreditLimit.clientePossuiConta,!l,!c)}),[n])},$e=e`
  query GetTagueamento($input: [GetTagueamentoInput]) {
    getTagueamento(input: $input) {
      id
      name
      brand
      category
      affiliation
      price
      quantity
      precisa_de_cotacao
      currency
      offer_id
    }
  }
`,Oe=({input:e})=>{const{called:i,loading:r,data:o,error:a}=t($e,{variables:{input:e},skip:!e});return{called:i,loading:r,data:o,error:a}},Ae=()=>{const[e,{called:i,loading:t,data:o,error:a}]=r($e,{fetchPolicy:"cache-first"});return{getTagueamento:e,called:i,loading:t,data:o,error:a}},Le=(e,i)=>null==e?void 0:e.map((e=>{var t,r;const o=null===(t=null==e?void 0:e.mp_info)||void 0===t?void 0:t.offers,a=y(o,null==i?void 0:i.regionList);return{item_id:null==e?void 0:e.partnumber,item_name:null==e?void 0:e.name,affiliation:null==a?void 0:a.shop_name,currency:"BRL",item_brand:null==e?void 0:e.marca,item_category:null===(r=null==e?void 0:e.parentCategory)||void 0===r?void 0:r.identifier,price:(null==e?void 0:e.precisa_de_cotacao)?"Sob-consulta":(null==a?void 0:a.price)?null==a?void 0:a.price:"indisponivel",quantity:1}})),Ne=()=>{const i=e`
    query PageRegistration {
      pageRegistration {
        terms_of_use
      }
    }
  `,r=t(i);return{getRegister:()=>r}},qe=e`
  query ValidateUser($client: String) {
    validateUser(client: $client) {
      isValidToken
      isActive
      isSocial
    }
  }
`,we=()=>{const{loading:e,error:i,data:r,called:o,refetch:a}=t(qe,{variables:{client:process.env.APLICACAO_SOLICITACAO_PEDIDO},fetchPolicy:"no-cache"});return{loading:e,error:i,data:r,called:o,refetch:a}},De=e`
  query ValidateUser($client: String) {
    validateUser(client: $client) {
      isValidToken
      isActive
      isSocial
    }
  }
`,Ee=()=>{const[e,{loading:i,error:t,data:o,called:a}]=r(De,{variables:{client:process.env.APLICACAO_SOLICITACAO_PEDIDO},fetchPolicy:"no-cache"});return{getLazyUserValidation:e,loading:i,error:t,data:o,called:a}};function Te(){const{innerWidth:e,innerHeight:i}=window;return{width:e,height:i}}function Re(){const[e,i]=c(Te());return s((()=>{function e(){i(Te())}return window.addEventListener("resize",e),()=>window.removeEventListener("resize",e)}),[]),e}const Ue=(e=!1)=>{var i;const t=te(e),r=u((()=>{var e,i;return(null===(i=null===(e=t.data)||void 0===e?void 0:e.fullName)||void 0===i?void 0:i.trim())||""}),[null===(i=t.data)||void 0===i?void 0:i.fullName]);return r},Fe=e`
  query Me {
    me {
      addresses {
        id
        title
        titleCode
        address1
        address2
        city
        company
        countryCode
        countryName
        firstName
        lastName
        name
        phone
        province
        zip
        email
        name_address
        number_address
        neighborhood_address
        recieve_shipping_name
        recieve_shipping_phone
        additional_shipping_info
        type_address
        recieve_shipping
        default_shipping
        default_billing
        cnpj
        inscricao_estadual
      }
    }
  }
`,je=()=>{const{loading:e,data:i,refetch:r}=t(Fe,{fetchPolicy:"network-only"});return{loading:e,data:i,refetch:r}},Ge=()=>{const[e,{data:i,loading:t,error:o}]=r(Fe,{fetchPolicy:"network-only"});return{getMeTeste:e,data:i,loading:t,error:o}},xe=({skip:e},i)=>{const r={__token:a().token},{called:o,loading:l,data:d,error:c,refetch:s}=t(n((e=>`\n        query Me {\n          me {\n            ${e}\n          }\n        }\n      `),i),{variables:r,skip:e});return{called:o,loading:l,data:d,refetch:s,error:c}},Be=e`
  query CartById($cartId: ID) {
    me {
      id
      creditAssurance
      creditLimit
      creditStore
      creditStoreName
      creditType
      hasCredit
      carts(cartId: $cartId) {
        id
        grandTotal {
          ...Currency
        }
        adjustments {
          title
          amount {
            ...Currency
          }
        }
        shippingInfo {
          shipMode {
            id
            identifier
          }
          pickupInStore {
            id
            name
          }
          shippingAddress {
            id
            countryName
            zip
            address1
            address2
          }
        }
        lineItems {
          id
          quantity
          partnumber
          linePrice {
            ...Currency
          }
          unitPrice {
            ...Currency
          }
          mp_info {
            shop_id
            offer_id
            shop_name
            cpr_available
          }
          product {
            id
            type
            thumbnail
            name
            partnumber
            slug
            precisa_de_receita
            accepts_cpr_payment
            entrega_expressa
            grande_desconto
            mp_info {
              offers {
                offer_id
                shop {
                  additional_info {
                    json_string
                  }
                }
              }
            }
          }
        }
        availablePaymentMethods {
          description
          id
          identifier
          type
        }
        mp_info {
          orders {
            leadtime_to_ship

            offers {
              id
              price
              shipping_price_unit
              offer_additional_fields {
                code
                value
              }

              line_shipping_price
              quantity

              allowed_shipping_types {
                code
                label
                delivery_time {
                  earliest_days
                }
                shipping_additional_fields {
                  value
                }
              }
            }
            shipping_types {
              code
              label
              total_shipping_price
              delivery_time {
                earliest_days
                latest_days
              }
            }
            currency_iso_code
            selected_shipping_type {
              code
              label
              delivery_time {
                earliest_days
                latest_days
              }
            }
          }
        }
      }
    }
  }
  fragment Currency on CmmMoney {
    value
    currency
  }
`,Me=new o,Ke="undefined"==typeof global?Me.get("marketplace"):null===global||void 0===global?void 0:global.MARKETPLACE_COOKIE,ze=(e="-1")=>{const i=a(),{data:r,loading:o,error:n,refetch:l,called:d}=t(Be,{fetchPolicy:"no-cache",variables:{cartId:e},skip:"-1"===e||((null==Ke?void 0:Ke.ISWEBVIEW)?!window.self:void 0===i.cartId),errorPolicy:"ignore"});return{data:r,loading:o,error:n,refetch:l,called:d}},He=()=>({getUserFileUrl:()=>r(e`
      query GetUserFileUrl($objectId: String) {
        getUserFileUrl(objectId: $objectId) {
          url
        }
      }
    `)}),Ve=()=>{const i=e`
    query GetClientProfile($cpf: ID!, $inviteCode: String) {
      getClientProfile(cpf: $cpf, inviteCode: $inviteCode) {
        cpf
        fullName
        email
        phoneNumber
        emailVerified
        contractsInProgress
        inviteCode
      }
    }
  `;return{getClientProfile:e=>{return r={cpf:e.replace(/\D+/g,"")},t(i,{variables:r});var r},getClientProfileLazy:()=>{const[e,t]=r(i,{variables:o});var o;return{clientProfileResponse:t,getClientProfile:(i,t="")=>{e({variables:{cpf:i.replace(/\D+/g,""),inviteCode:t}})}}}}},Qe=()=>{const o=e`
    query GetPrivilegedUserSession($privilegedSessionId: String) {
      getPrivilegedUserSession(privilegedSessionId: $privilegedSessionId) {
        statusCode
        clientCPFCNPJ
        clientName
        clientEmail
        clientPhone
      }
    }
  `,a=e`
    mutation CreatePrivilegedUserSession($input: SessionInput) {
      createPrivilegedUserSession(input: $input) {
        privilegedSessionId
      }
    }
  `,[n]=i(a);return{getPrivilegedUserSession:e=>{return i={privilegedSessionId:e},r={skip:!e},t(o,Object.assign(Object.assign({},r),{variables:i}));var i,r},getPrivilegedUserSessionLazy:()=>{const[e,i]=r(o,{variables:t});var t;return{privilegedUserSessionResponse:i,getPrivilegedUserSession:i=>{e({variables:{privilegedSessionId:i}})}}},createPrivilegedUserSession:e=>n({variables:{input:e}})}},Je=()=>{const t=e`
    mutation UpdateOrderViewed($orderNumber: String) {
      updateOrderViewed(orderNumber: $orderNumber) {
        statusCode
        message
      }
    }
  `,[r]=i(t,{update(e){e.modify({fields:{getSpecialistOrders:()=>{}}})}});return{updateOrderViewed:e=>r({variables:{orderNumber:e}})}};function We(){const e=g(),i=p(),t=u((()=>({pathname:e.pathname,search:h.parse(e.search,{ignoreQueryPrefix:!0})})),[e.search,e.pathname]),r=d(((e,{path:r=t.pathname}={})=>{r===t.pathname?i.replace({pathname:r,search:h.stringify(e)}):i.push({pathname:r,search:h.stringify(e)})}),[i,t.pathname]);return[t.search,r]}const Ze=()=>{const i=e`
    query GetPossibleClientsByName(
      $filter: Filter!
      $pagination: ClientPagination
    ) {
      getPossibleClientsByName(filter: $filter, pagination: $pagination) {
        page
        perPage
        lastPage
        total
        data {
          cpf
          fullName
          email
          phoneNumber
          emailVerified
          inviteCode
        }
      }
    }
  `;return{getPossibleClients:({filter:e={search:""},pagination:r={page:1,perPage:5}}={})=>({possibleClientsResponse:t(i,{variables:{filter:e,pagination:r},notifyOnNetworkStatusChange:!0})}),getPossibleClientsLazy:()=>{const[e,t]=r(i,{variables:o,notifyOnNetworkStatusChange:!0});var o;return{possibleClientsResponse:t,getPossibleClients:({filter:i={search:""},pagination:t={page:1,perPage:5}}={})=>e({variables:{filter:i,pagination:t}})}}}};var Xe;!function(e){e.ME="SPECIALIST",e.SPECIALIST="OTHER_SPECIALIST",e.CLIENT="CLIENT",e.OTHER="OTHER"}(Xe||(Xe={}));const Ye=()=>{const i=e`
    query GetSpecialistOrders($input: OrderFilter) {
      getSpecialistOrders(input: $input) {
        page
        perPage
        lastPage
        total
        data {
          id
          numeroPedido
          modalidadeCredito
          situacaoFormalizacao
          origemPedido
          perfilUsuarioSolicitacaoPedido
          idUsuarioSolicitacaoPedido
          nomeCliente
          numeroCPFCNPJ
          produto
          valorTotalFormalizacao
          datahoraInclusaoFormalizacao
          dataExpiracao
          datahoraInclusaoFormalizacao
        }
      }
    }
  `;return{getOrderList:({ordenation:e={orderBy:"ACCESS",orderBasis:"DESC"},pagination:r={page:1,perPage:5}}={})=>{var o;return{orderListResponse:(o={input:{pagination:r,ordenation:e.orderBy}},t(i,{variables:o,notifyOnNetworkStatusChange:!0}))}},getOrderListLazy:()=>{const[e,t]=r(i,{variables:o,notifyOnNetworkStatusChange:!0});var o;return{orderListResponse:t,getOrderList:({ordenation:i={orderBy:"ACCESS",orderBasis:"DESC"},pagination:t={page:1,perPage:5}}={})=>e({variables:{input:{pagination:t,ordenation:i.orderBy}}})}}}},ei=()=>{const i=e`
    query GetOrderByOrderNumber($orderNumber: String!, $orderOrigin: String) {
      getOrderByOrderNumber(
        orderNumber: $orderNumber
        orderOrigin: $orderOrigin
      ) {
        id
        numeroPedido
        modalidadeCredito
        situacaoFormalizacao
        numeroCPFCNPJ
        origemPedido
        perfilUsuarioSolicitacaoPedido
        idUsuarioSolicitacaoPedido
        nomeCliente
        produto
        valorTotalFormalizacao
        dataExpiracao
        datahoraInclusaoFormalizacao
      }
    }
  `;return{getOrderByNumber:(e,r=null)=>{return o={orderNumber:e.replace(/\D+/g,""),orderOrigin:r},t(i,{variables:o});var o},getOrderByNumberLazy:()=>{const[e,t]=r(i,{variables:o});var o;return{orderByNumberResponse:t,getOrderByNumber:(i,t=null)=>{e({variables:{orderNumber:i.replace(/\D+/g,""),orderOrigin:t}})}}}}},ii=()=>{const i=e`
    query GetParameter($groupType: String!) {
      getParameter(groupType: $groupType) {
        id
        descricaoParametro
        modalidadeParametro
        unidadeParametro
        categoriaParametro
        tipoParametro
      }
    }
  `;return{getStatusOrder:()=>t(i,{variables:{groupType:"STATUS_FORMALIZACAO"}})}},ti=()=>{var e,i;const{loading:t,data:r}=X();return(!t||r)&&(null===(e=null==r?void 0:r.getProfile)||void 0===e?void 0:e.fullName)?`Olá, ${null===(i=null==r?void 0:r.getProfile)||void 0===i?void 0:i.fullName.split(" ")[0]}`:"Loja e-agro"},ri=e`
  query ConsultCEP($cep: String!) {
    consultCEP(cep: $cep) {
      cep
      cepFormatado
      numeroCep
      complementoCep
      tipoLogradouro
      logradouro
      bairro
      municipio
      siglaEstado
      tipoLocalidade
      idMunicipioBacen
      idEstadoBacen
      idMunicipioIbge
      idEstadoIbge
      agenciaDepositaria
      codigoDistribuicao
    }
  }
`;function oi(){const[e,{loading:i,error:t,data:o,refetch:a,called:n}]=r(ri,{fetchPolicy:"network-only"});return{getLocationData:e,data:{loading:i,error:t,locationData:o,refetch:a,called:n}}}const ai=()=>{const i=e`
    query GetBusinessHours {
      getBusinessHours {
        to
        from
        isHoliday
      }
    }
  `,[t,{data:o,loading:a,error:n}]=r(i);return{getBusinessHours:t,data:o,loading:a,error:n}};var ni,li,di;!function(e){e.Price="price",e.PriceUrl="preco",e.AcceptsCprPayment="accepts_cpr_payment",e.Stores="mirakl_shop_ids",e.MiraklRegion="mirakl_region",e.ExpressDelivery="entrega_expressa",e.PriceOnly="precisa_de_cotacao",e.BigDiscount="grande_desconto",e.Releases="lancamento",e.Brand="marca_busca",e.TypeCPR="tipo_cpr",e.HasOffersClosePrice="has_offers_close_price",e.ShowPrice="show_price",e.CategoryUid="category_uid",e.AcceptedAssuranceTypesBucket="accepted_assurance_types_bucket",e.MiraklOfferStateIds="mirakl_offer_state_ids",e.TypeBucketCpr="tipo_cpr_bucket",e.NeedQuote="precisa_de_receita"}(ni||(ni={})),function(e){e.ExpressDelivery="entrega_expressa",e.PriceOnly="precisa_de_cotacao",e.BigDiscount="grande_desconto",e.Releases="lancamento"}(li||(li={})),function(e){e.Default="Default",e.Price="Price",e.SpecialFilters="SpecialFilters",e.CPR="CPR",e.Stores="Stores"}(di||(di={}));const ci=e`
  query GetCategoryPageDetails($input: CategoryPageDetailsInput!) {
    getCategoryPageDetails(input: $input) {
      breadcrumbs {
        label
        url
      }
      category {
        uid
        urlKey
        title
        titleFooter
        image
        description
      }
      subcategories {
        label
        value
        count
      }
      offers {
        name
        urlKey
        offerId
        sku
        quantity
        minOrderQuantity
        additional_info {
          json_string
        }
        cc_installments {
          num_installment
          price_installment
          interest
        }
        price {
          regularPrice
          finalPrice
          discount {
            percentOff
            amountOff
          }
        }
        imageThumb
        brand
        shop {
          name
          additional_info {
            json_string
          }
        }
        showPrice
        offerType
        flags {
          title
          color
          isAlwaysVisible
        }
        otherOffersAmount
        productType
        categories {
          urlKey
        }
        isExclusiveCpr
      }
      filters {
        type
        filtersDefault {
          code
          label
          options {
            label
            value
            isSelected
            url
            count
          }
        }
        priceRange {
          minPrice
          minPriceSelected
          maxPrice
          maxPriceSelected
          url
        }
        specialFilters {
          type
          label
          code
          isSelected
          url
        }
        cprFilter {
          code
          isSelected
          url
        }
        stores {
          imageLogo
          urlKey
          name
          selectedFilters
        }
      }
      filterSuggestions {
        label
        value
        isSelected
        url
      }
      deeplinks {
        label
        value
        url
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalItems
      }
      selectedFilters {
        code
        path
        label
        url
      }
      seo {
        title
        description
        robots
        keywords
        url
        canonical
      }
    }
  }
`,si=e`
  query GetCategoryPageCarousel($input: GetCategoryPageCarouselInput!) {
    getCategoryPageCarousel(input: $input) {
      title
      offers {
        name
        urlKey
        offerId
        sku
        quantity
        minOrderQuantity
        price {
          regularPrice
          finalPrice
          discount {
            percentOff
            amountOff
          }
        }
        imageThumb
        brand
        shop {
          name
          additional_info {
            json_string
          }
        }
        showPrice
        offerType
        flags {
          title
          color
          isAlwaysVisible
        }
        otherOffersAmount
        productType
        categories {
          urlKey
        }
        isExclusiveCpr
      }
    }
  }
`;var ui;!function(e){e.Name="Name",e.Relevance="Relevance",e.PriceAscending="PriceAscending"}(ui||(ui={}));const pi=({input:e})=>{var i,r;const{data:o,error:a,loading:n,refetch:l}=t(ci,{variables:{input:e},skip:null===(r=null===(i=null==e?void 0:e.filter)||void 0===i?void 0:i.categoryId)||void 0===r?void 0:r.includes("manifest.json")});return{categoryData:null==o?void 0:o.getCategoryPageDetails,error:a,loading:n,refetch:l}},gi=({input:e})=>{var i;const{data:r,error:o,loading:a,refetch:n}=t(si,{variables:{input:e},skip:null===(i=null==e?void 0:e.categoryId)||void 0===i?void 0:i.includes("manifest.json")});return{catalogCarouselData:null==r?void 0:r.getCategoryPageCarousel,error:o,loading:a,refetch:n}},fi=(e,i)=>{if(!e||!i)return e;const[t,r]=(e||"").split("/f/");if(!r)return e;const[o,a]=(r||"").split("?"),[n,l]=(null==o?void 0:o.includes("/n/"))?o.split("/n/"):[o,""],d=n?null==n?void 0:n.split("/"):[],c=l?null==l?void 0:l.split("/"):[],s=null==d?void 0:d.filter((e=>!(null==i?void 0:i.includes(e)))),u=null==c?void 0:c.filter((e=>!(null==i?void 0:i.includes(e))));return`${t}${(null==s?void 0:s.length)?`/f/${null==s?void 0:s.join("/")}`:""}${(null==u?void 0:u.length)?`${(null==s?void 0:s.length)?"":"/f"}/n/${null==u?void 0:u.join("/")}`:""}${void 0!==a&&""!==a?`?${a}`:""}`},mi=e=>{const[i,t]=e.split("/f/"),[r,o]=t.split("?");return`${i}${void 0!==o&&""!==o?`?${o}`:""}`};var vi,yi,hi;!function(e){e.Image="image",e.Video="video"}(vi||(vi={})),function(e){e.ShowPrice="ShowPrice",e.Budget="Budget",e.QuickLead="QuickLead",e.ShowPriceLogin="ShowPriceLogin",e.NotAvailableRegionNotSelected="NotAvailableRegionNotSelected",e.NotAvailableRegion="NotAvailableRegion",e.NotAvailable="NotAvailable"}(yi||(yi={})),function(e){e.SimpleProduct="SimpleProduct",e.ConfigurableProduct="ConfigurableProduct"}(hi||(hi={}));const _i=e`
  query GetProductDetailsPage($input: ProductDetailsPageInput!) {
    getProductDetailsPage(input: $input) {
      sku
      name
      breadcrumbs {
        label
        url
      }
      shortDescription
      longDescription
      attachments {
        type
        url
      }
      flags {
        title
        color
        isAlwaysVisible
      }
      acceptsCprPayment
      needRecipe
      needQuote
      offerIdToShowFirst
      configurableOptions {
        options {
          header {
            attributeCode
            label
          }
          values {
            uid
            label
            headerCode
          }
        }
        variants {
          values
          products {
            offerId
          }
        }
      }
      additionalDetails {
        datasheetList {
          label
          value
        }
        documentEmergencyFormUrl
        documentTechnicalSheetUrl
        documentFispqUrl
      }
      deeplinks {
        label
        url
      }
      offers {
        name
        urlKey
        offerId
        sku
        quantity
        minOrderQuantity
        imageThumb
        acceptsCprPayment
        shop {
          id
          name
          cpfCnpjSeller
          urlKey
          premium
          logo
          isCprOtherGuarantees
          isCprGuarantor
          sellerHasEfinance
          additional_info {
            json_string
          }
          enableLeadWhatsapp
          whatsappNumber
        }
        showPrice
        offerType
        brand
        flags {
          title
          color
          isAlwaysVisible
        }
        cc_installments {
          num_installment
          price_installment
          interest
        }
        price {
          regularPrice
          finalPrice
          discount {
            percentOff
            amountOff
          }
        }
        otherOffersAmount
        productType
        categories {
          urlKey
        }
        isExclusiveCpr
        isCprMaquinas
        codeModalityCredit
      }
    }
  }
`,bi=e`
  query GetProductDetailsPageCarousel(
    $input: ProductDetailsPageCarouselInput!
  ) {
    getProductDetailsPageCarousel(input: $input) {
      offersSeller {
        name
        urlKey
        offerId
        sku
        quantity
        minOrderQuantity
        cc_installments {
          interest
          num_installment
          price_installment
        }
        price {
          regularPrice
          finalPrice
          discount {
            percentOff
            amountOff
          }
        }
        imageThumb
        brand
        additional_info {
          json_string
        }
        shop {
          name
          additional_info {
            json_string
          }
        }
        showPrice
        offerType
        flags {
          title
          color
          isAlwaysVisible
        }
        otherOffersAmount
        productType
        categories {
          urlKey
        }
        isExclusiveCpr
        isCprMaquinas
      }
    }
  }
`,Pi=({input:e})=>{var i;const{data:r,error:o,loading:a,refetch:n}=t(_i,{variables:{input:e},skip:null===(i=null==e?void 0:e.urlKey)||void 0===i?void 0:i.includes("manifest.json")});return{productData:null==r?void 0:r.getProductDetailsPage,error:o,loading:a,refetch:n}},Ci=({input:e})=>{var i;const{data:r,error:o,loading:a,refetch:n}=t(bi,{variables:{input:e},skip:null===(i=null==e?void 0:e.urlKey)||void 0===i?void 0:i.includes("manifest.json")});return{productCarouselData:null==r?void 0:r.getProductDetailsPageCarousel,error:o,loading:a,refetch:n}},Si=(e,i,t)=>{var r,o;let a=[];return e&&i&&0===(null==i?void 0:i.length)?a=null===(r=null==e?void 0:e.offers)||void 0===r?void 0:r.filter((e=>(null==e?void 0:e.offerId)!==(null==t?void 0:t.offerId))):void 0!==e&&(a=null===(o=null==e?void 0:e.offers)||void 0===o?void 0:o.filter((e=>null==i?void 0:i.find((i=>null==i?void 0:i.find((i=>i===(null==e?void 0:e.offerId)&&(null==e?void 0:e.offerId)!==(null==t?void 0:t.offerId)))))))),a=null==a?void 0:a.filter((e=>(null==e?void 0:e.offerType)!==yi.NotAvailableRegion)),a};var Ii;!function(e){e.Pix="aarin_pix",e.Boleto="braspag_pagador_boleto",e.CreditCard="braspag_pagador_creditcard",e.CPR="cpr_payment"}(Ii||(Ii={}));const ki=e`
  query GetCheckoutDetails($cartId: ID!) {
    getCheckoutDetails(cartId: $cartId) {
      id
      shippingOptions {
        title
        shippingOptionsList {
          code
          title
          deliveryTime
          price
          selected
          withdrawalDetails {
            shopName
            shopAddress
          }
          offerId
        }
      }
      paymentMethods {
        code
        title
        message
        isNew
        cprCreditLimit
        creditCardBrands
        isEnabled
      }
      items {
        id
        thumbnail
        shopName
        shopPremium
        productName
        brand
        category
        productConfigurableOptions
        quantitySelected
        productQuantity
        minOrderQuantity
        totalPrice
        totalRegularPrice
        discountPercentOff
        offerId
      }
      totals {
        subtotal
        subtotalWithoutDiscount
        discount
        shipping
        total
      }
      userCprCredit {
        creditStoreName
        creditType
        creditStore
        creditLimit
        creditAssurance
        hasCredit
        correntista
      }
      userData {
        firstName
        lastName
        email
        cellphone
      }
    }
  }
`,$i=e=>{const{data:i,loading:r,error:o,refetch:a}=t(ki,{fetchPolicy:"no-cache",variables:{cartId:e},skip:!e});return{data:null==i?void 0:i.getCheckoutDetails,loading:r,error:o,refetch:a}};var Oi,Ai;!function(e){e.Visa="visa",e.Mastercard="mastercard",e.Diners="diners",e.Amex="amex",e.Discover="discover",e.Hipercard="hipercard",e.Elo="elo",e.Jcb="jcb",e.Aura="aura",e.Hiper="hiper",e.Sorocred="sorocred"}(Oi||(Oi={})),function(e){e.Canceled="Canceled",e.Processing="Processing",e.Pending="Pending"}(Ai||(Ai={}));const Li=i=>{const r=e`
    query GetCheckoutOrderDetails($orderNumber: String!) {
      getCheckoutOrderDetails(orderNumber: $orderNumber) {
        items {
          offerId
          thumbnail
          shopName
          shopPremium
          productName
          brand
          category
          productConfigurableOptions
          quantity
          totalPrice
        }
        orderNumber
        orderStatus
        orderStatusTitle
        orderStatusMessage
        totals {
          total
        }
        contactInformation {
          email
          phone
        }
        deliveryAddress {
          name
          cpf
          address
        }
        paymentMethod {
          code
          title
          pix {
            link_qr_code
            payload
          }
          boleto {
            title
            message
            url
            digitableLine
          }
          creditCard {
            brand
            installments
          }
          cpr {
            simulationId
            simulationNumber
          }
        }
        shippingOptions {
          productName
          shippingMethodName
          deliveryTime
          price
        }
      }
    }
  `,{called:o,loading:a,data:n,error:d,refetch:c}=t(r,{fetchPolicy:"no-cache",variables:{orderNumber:i},skip:!i});l(__filename,d);return{called:o,loading:a,dataCheckoutOrder:null==n?void 0:n.getCheckoutOrderDetails,error:d,refetch:c}},Ni=e`
  query GetUserAddresses {
    getUserAddresses {
      id
      firstname
      lastname
      telephone
      recieveShippingName
      postcode
      state
      city
      neighborhood
      street
      number
      complement
      cnpj
      stateRegistration
      defaultShipping
      defaultBilling
      full_address
      countryName
      additionalShippingInfo
      recieveShippingPhone
      recieveShipping
      nameAddress
      email
      typeAddress {
        name
        id
      }
    }
  }
`,qi=()=>{const{loading:e,data:i,error:r,refetch:o}=t(Ni,{fetchPolicy:"network-only"});return{loading:e,data:null==i?void 0:i.getUserAddresses,error:r,refetch:o}},wi=()=>{const[t]=i(e`
      mutation CheckoutOrderFeedback(
        $orderNumber: String!
        $feedback: [CheckoutOrderFeedbackInput!]!
      ) {
        checkoutOrderFeedback(orderNumber: $orderNumber, feedback: $feedback) {
          status
        }
      }
    `);return{checkoutOrderFeedback:(e,i)=>b(void 0,void 0,void 0,(function*(){return t({variables:{orderNumber:e,feedback:i}})}))}},Di=()=>{const[t]=i(e`
    mutation CartSetShippingInfo($cartId: ID!, $address: CusAddressInput) {
      cartSetShippingInfo(cartId: $cartId, address: $address)
    }
  `);return{cartSetShippingInfo:(e,i)=>b(void 0,void 0,void 0,(function*(){return t({variables:{cartId:e,address:i}})}))}},Ei=e`
  query GetAddressByZipcode($input: GetAddressByZipcodeRequest!) {
    getAddressByZipcode(input: $input) {
      cep
      cepFormatado
      numeroCep
      complementoCep
      tipoLogradouro
      logradouro
      bairro
      municipio
      siglaEstado
      tipoLocalidade
      idMunicipioBacen
      idEstadoBacen
      idMunicipioIbge
      idEstadoIbge
      agenciaDepositaria
      codigoDistribuicao
    }
  }
`;function Ti(){const[e,{loading:i,error:t,data:o,called:a}]=r(Ei,{fetchPolicy:"network-only"});return{fetchAddressByZipcode:e,data:{loading:i,error:t,addressData:o,called:a}}}export{ui as CatalogSort,di as CategoryPageDetailsFiltersType,Ai as CheckoutOrderDetailsStatus,Oi as CreditCardBrand,ni as FacetType,ee as GetShippingOnProductPageCode,ue as MarketplaceCookies,Xe as OrderSourceEnum,Ii as PaymentMethodType,vi as ProductDetailsPageAttachmentType,hi as ProductDetailsPageOfferProductType,yi as ProductDetailsPageOfferType,q as QUERY_GET_CREDIT_LIMIT,li as SpecialFiltersType,Ue as Username,ti as UsernameMKT,Le as getOffersMappedTagueamento,Si as getOffersToBuyBox,mi as removeAllFiltersUrl,fi as removeFiltersUrl,_ as useAgroLogout,P as useAskQuestion,S as useAuthentication,I as useCMSDashboardBannerDownload,Di as useCartSetShippingInfo,$ as useCategories,A as useCategory,wi as useCheckoutOrderFeedback,oi as useConsultCep,D as useCreditCPRF,E as useCreditCPRFLimit,F as useCreditCPRFLimitLazy,R as useCreditClientHasAccount,U as useCreditClientHasAccountLazy,j as useDoesCityHasProductsAvailable,G as useDropdownCategoriasBanner,x as useFooter,Ti as useGetAddressByZipcode,je as useGetAddressUser,Ge as useGetAddressUserLazyQuery,ai as useGetBusinessHours,pi as useGetCatalogDetailsPage,gi as useGetCatalogPageCarousel,$i as useGetCheckoutDetails,Li as useGetCheckoutOrderDetails,Ve as useGetClientProfile,B as useGetHeader,K as useGetIdBrRegion,Q as useGetMunicipio,ei as useGetOrderByOrderNumber,J as useGetOrderDataPrivileged,Ye as useGetOrderList,ii as useGetParameter,Ze as useGetPossibleClients,ze as useGetProductCart,Z as useGetProductDeeplinks,Pi as useGetProductDetailsPage,Ci as useGetProductDetailsPageCarousel,X as useGetProfile,ie as useGetShippingOnProductPage,te as useGetSpecialistProfile,qi as useGetUserAddresses,T as useGetUserCreditInfo,He as useGetUserFileUrl,H as useLazyGetMunicipio,V as useLazyMunicipio,ve as useLazyProducts,Ae as useLazyTagueamento,ne as useLinkRegister,ae as useLocalStorage,le as useManageUserFile,xe as useMe,pe as useNotificationBell,oe as useOIDC,N as usePrivilegedSession,Qe as usePrivilegedUserSession,fe as useProduct,me as useProducts,We as useQueryParams,re as useRedirect,ye as useRedirectSSO,_e as useRefreshCart,Ne as useRegisterPage,be as useSEO,Ce as useSendStockNotification,ke as useSetUserInfo,Oe as useTagueamento,Je as useUpdateOrderViewed,we as useValidToken,Ee as useValidTokenLazy,Re as useWindowDimensions};
//# sourceMappingURL=bundle.esm.js.map
